export default "__VITE_ASSET__BivopR0L__"